
import styles from "./PhotoTab.module.scss";
import classNames from "classnames/bind";

const cx = classNames.bind(styles);

const PhotoImage = ({ url }: { url: string }) => {
  if (!url) {
    return <div className={cx("photo-img-preview")} />;
  }

  return <img src={url} className={cx("photo-img-preview")} alt="" />;
};

export default PhotoImage;
